var _circle, _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgAccount = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 4.22857,
    transform: "matrix(-1 0 0 1 11.9999 6.72857)",
    fill: "#98A2B2",
    stroke: "#98A2B2",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.59961 17.2309C4.59961 16.3214 5.17137 15.5101 6.02791 15.2042V15.2042C9.88959 13.825 14.1096 13.825 17.9713 15.2042V15.2042C18.8278 15.5101 19.3996 16.3214 19.3996 17.2309V18.694C19.3996 19.9111 18.3216 20.846 17.1168 20.6739L15.818 20.4883C13.2853 20.1265 10.714 20.1265 8.18123 20.4883L6.88245 20.6739C5.67759 20.846 4.59961 19.9111 4.59961 18.694V17.2309Z",
    fill: "#98A2B2",
    stroke: "#98A2B2",
    strokeWidth: 1.5
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAccount, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/account.d2fe2087.svg";
export { ForwardRef as ReactComponent };